import React from 'react';
import { useSelector } from 'react-redux';

import MapContainer from './features/map/MapContainer';
import Tabs from './features/Tabs';

import { selectMode } from './features/selectors';

import { setDataAsync, setMode } from './features/reducers/mapDataSlice';
import { useDispatch } from 'react-redux';

import './App.css';

function App() {
  const dispatch = useDispatch();
  const mode = useSelector((state) => selectMode(state));

  const onTabClick = (newMode) => {
      if (newMode !== mode) {
        dispatch(setMode(newMode));
        dispatch(setDataAsync(newMode));
      }
  }

  return (
    <div className="demo">
      <Tabs mode={mode} onTabClick={onTabClick} />
      <div className="tab-content">
        <MapContainer mode={mode}/>
      </div>
    </div>
  );
}

export default App;
